import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#454545",
      class: "background",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M30.4 10H13.6C10.52 10 8 12.47 8 15.486V34l5.6-4.8h16.8c3.08 0 5.6-2.469 5.6-5.486v-8.228C36 12.469 33.48 10 30.4 10Zm-16.8 8.914h13.3v1.372H13.6v-1.372ZM30.4 24.4H13.6v-1.371h16.8V24.4Zm0-8.228H13.6V14.8h16.8v1.372Z",
      class: "foreground"
    }, null, -1)
  ])))
}
export default { render: render }